import { useParams } from 'react-router-dom';
import { Steps } from '../consts/step';

export const useStepName = () => {
  const { stepName } = useParams();
  return stepName as Steps;
};
